import React from "react";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
  Label,
} from "reactstrap";
import InputMask from "react-input-mask";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Switch from "components/switch/Switch";

import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import Header from "components/Headers/Header.js";
import Api from "shared/resources/Api";

export default class LogsContaOvosList extends React.Component {
  /* Dados Grid */
  columns = [
    {
      name: "ID",
      selector: "oid_log",
      sortable: true,
    },
    {
      name: "Ovitrampa Movimento",
      selector: "oid_ovitrampa_movimento",
      sortable: true,
    },
    {
      name: "Ovitrampa",
      selector: "oid_ovitrampa",
      sortable: true,
    },
    {
      name: "Serviço",
      selector: "nm_service",
      sortable: true,
    },
    {
      name: "Status",
      selector: "request",
      sortable: true,
      cell: (row) => (
        <div>{row.vs_versao === 1 ? <span className="badge badge-success">Sucesso</span> : <span className="badge badge-danger">Erro</span>}</div>
      ),
    },
    {
      name: "Requisição",
      selector: "request",
      sortable: true,
      cell: (row) => (
        <div>
          <Button                           
            className="mt-4 btn-zoo-alt"
            color="primary"
            type="button"
            onClick={()=> {
              Swal.fire({
                title: "Dados enviados ao Conta Ovos",
                html: `<pre style="text-align: left; white-space: pre-wrap;">${
                  row.request 
                    ? JSON.stringify(JSON.parse(this.convertData(row.request)), null, 2).slice(1, -1)
                    : ""
                }</pre>`
            })}}>
              <FontAwesomeIcon icon={faEye} className="edit" />
            </Button>
        </div>
      ),
    },
        {
      name: "Resposta",
      selector: "response",
      sortable: true,
       cell: (row) => (
        <div>
          <Button                           
            className="mt-4 btn-zoo-alt"
            color="primary"
            type="button"
            onClick={()=> {
              Swal.fire({
                title: "Dados recebidos do Conta Ovos",
                html: `<pre style="text-align: left; white-space: pre-wrap;">${
                  row.response 
                    ?   (() => {
                      const parsed = JSON.parse(row.response);
                      const value = parsed.error || parsed.data;
                      const stringified = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
                      return typeof value === 'string' ? stringified : stringified.slice(1, -1);
                    })()
                    : ""
                }</pre>`
            })}}>
             <FontAwesomeIcon icon={faEye} className="edit" />
            </Button>
        </div>
      ),
    },    
    /*{
      name: "Data Criação",
      selector: "dt_criacao",
      sortable: true,
      cell: (row) => (
        <div>{moment(moment(row.dt_criacao)).format("DD/MM/YYYY")}</div>
      ),
    },*/
    {
      name: "Data criação",
      selector: "dt_criacao",
      sortable: true,
    }
    
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      id_ovitrampa: "",
      id_ovitrampa_movimento: "",
      data_inicio: moment().subtract(1, "weeks").format("DD/MM/YYYY"),
      data_fim: moment().format("DD/MM/YYYY"),
      api: Api.baseURL,
      response: [],
      requesting: false,
      status: "",
      sync: false,
      active: false,
      conta_ovos:{id:0, tp_ativo:false}
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentWillMount() {
    document.addEventListener("keydown", (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.handleSubmit(event);
      }
    });
    this.handleSubmit(new Event("submit"));
    this.fetchIntegracao();

  }

  handleSubmit(event) {
    this.setState({ requesting: true });
    this.fetchSketch()
    event.preventDefault();
  }
  fetchIntegracao = async () => {
    let params = {
      razao: 'CONTA OVOS',
    };
    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");
    let host = this.state.api + "/Fornecedores?status=";

    let path =
      this.state.status === "todos"
        ? "&" + query
        : this.state.status + "&" + query;

    const response = await fetch(host + path, {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      let resp = body
      resp[0].tp_ativo = body[0].tp_ativo == 'A' ? true:false;
      this.setState({
        conta_ovos: resp[0],
      });
    } else {
    console.log('integração não encontrada')
    }
    return body;
  };

    callSave = async () => {

      let data = JSON.parse(JSON.stringify(this.state.conta_ovos));
      data.tp_ativo = this.state.conta_ovos.tp_ativo ? "A": "I";
      data = JSON.stringify(data)
      const response = await fetch(
        Api.baseURL +
        "/Fornecedores/" +this.state.conta_ovos.id
          ,
        {
          method: "PUT" ,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("agToken"),
          },
          body: `{"fornecedores": ${data}}`,
        }
      );
  
      const body = await response.json();
  
      if (response.status === 200 && body.sucesso === true) {
        Swal.fire({
          title: this.state.conta_ovos.tp_ativo ?
            "Integração ativada com sucesso":
            "Integração desativada com sucesso",
          text: "",    
        })
      } else if (body.sucesso === false) {
          Swal.fire({
          title: "Atenção!",
          text: body.erro,    
        })
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text: body.erro,
            type: "warning",
          },
        });
        console.log(body.erro);
      } else {
        Swal.fire({
          title: this.state.conta_ovos.tp_ativo ?
            "Erro ao ativar a integração":
            "Erro ao desativar a integração",
          text: "",    
        })
        console.log(body.erro);
      }
  
      return body;
    };
  
  convertData = (data) => {
    if (!data) return "";

        data = data.replace('ovitrap_group_id', 'id_ovitrampa');
        data = data.replace('counting_observation_id', 'id_ovitrampa_movimento');
        data = data.replace('ovitrap_address_district', 'Bairro');
        data = data.replace('ovitrap_address_street', 'Logradouro');
        data = data.replace('ovitrap_address_number', 'Número');
        data = data.replace('ovitrap_address_complement', 'Complemento');
        data = data.replace('ovitrap_address_loc_inst', 'Localização');
        data = data.replace('ovitrap_lat', 'Latitude');
        data = data.replace('ovitrap_lng', 'Longitude');
        data = data.replace('ovitrap_address_sector', 'Setor');
        data = data.replace('ovitrap_responsable', 'Responsável');
        data = data.replace('ovitrap_block_id', 'Quarteirão');
        data = data.replace('date', 'Data de envio');
        data = data.replace('ovitrap_responsable', 'Responsável');
        data = data.replace('ovitrap_block_id', 'Quarteirão');
        data = data.replace('ovitrap_address_sector', 'Setor');
        data = data.replace('ovitrap_responsable', 'Responsável');
        data = data.replace('ovitrap_block_id', 'Quarteirão');
        data = data.replace('counting_observation_id', 'id_ovitrampa_movimento');
        data = data.replace('counting_date_collect', 'Data de envio na semana epidemiológica');
        data = data.replace('date', 'Data de envio');
        data = data.replace('counting_observation', 'Observações');
        data = data.replace('counting_eggs', 'Número de ovos');
        return data;    
  }



  syncContaOvos = async () => {
    this.setState({ sync: true });
    Swal.fire({
          title: "Sincronizando...",
          text: "Os dados estão sendo sincronizados! Esta ação pode demorar alguns minutos.",    
    })
    const response = await fetch(this.state.api + "/integration/init", {
      method: "get",
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    this.setState({ sync: false });
    Swal.fire({
      title: "Sincronização Concluída",
      text: "Os dados foram sincronizados com sucesso!",    
    })
    this.handleSubmit(new Event("submit"));
  }


  fetchSketch = async () => {
    
    let params =  {
      id_ovitrampa_movimento: this.state.id_ovitrampa_movimento,
      id_ovitrampa: this.state.id_ovitrampa,
      status: this.state.status,
      data_inicio: this.state.data_inicio
        ? moment(this.state.data_inicio, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "",

      data_fim: this.state.data_fim
        ? moment(this.state.data_fim, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "",
    };
    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    let host = this.state.api + "/contaovos?";

    const response = await fetch(host + query, {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
      
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        response: body,
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Não foram encontrados registros para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }

    return body;
  };

  render() {
    return (
      <>
        <Header />

        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Consulta Logs Conta Ovos
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Ovitrampa Movimento
                            </label>
                            <Input
                              type="number"
                              name="id_ovitrampa_movimento"
                              id="id_ovitrampa_movimento"
                              className="form-control"
                              inputMode="numeric"
                              value={this.state.id_ovitrampa_movimento}
                              onChange={(e) =>
                                this.setState({ id_ovitrampa_movimento: e.target.value })
                              }
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Ovitrampa
                            </label>
                            <Input
                              type="number"
                              name="id_ovitrampa"
                              id="id_ovitrampa"
                              className="form-control"
                              inputMode="numeric"
                              value={this.state.id_ovitrampa}
                              onChange={(e) =>
                                this.setState({ id_ovitrampa: e.target.value })
                              }
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Status
                            </label>
                            <select
                              value={this.state.status}
                              onChange={(e) => {
                                this.setState({ status: e.target.value });
                              }}
                              className="form-control "
                              id="select-tipo"
                            >
                              <option checked value="">Todos</option>
                              <option value="1">Sucesso</option>
                              <option value="0">Erro</option>
                            </select>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                         <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Data Inicial
                            </label>
                            <InputMask
                              mask="99/99/9999"
                              type="text"
                              name="data_inicio"
                              inputMode="numeric"
                              id="data_inicio"
                              className="form-control"
                              value={this.state.data_inicio}
                              onChange={(e) =>
                                this.setState({
                                  data_inicio: e.target.value,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Data Final
                            </label>

                            <InputMask
                              mask="99/99/9999"
                              type="text"
                              name="data_fim"
                              id="data_fim"
                              inputMode="numeric"
                              className="form-control"
                              value={this.state.data_fim}
                              onChange={(e) =>
                                this.setState({
                                  data_fim: e.target.value,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>

                      </Row>
                    </div>
                    <div>
                      <Row>
                        <Col xl="12">
                        
                            <div className="pl-lg-4">
                            <Label>
                              Status da integração
                            </Label><br></br> 
                              <Switch
                                isOn={this.state.conta_ovos.tp_ativo}
                                handleToggle={() => {
                                  this.setState({ conta_ovos:{...this.state.conta_ovos, tp_ativo : !this.state.conta_ovos.tp_ativo }});
                                  this.callSave();
                                }}
                              />
                            </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="text-center">
                      <Row>
                        <Col className="order-xl-1" xl="12">
                          <Button
                            className="mt-4 btn-zoo-alt"
                            color="primary"
                            type="button"
                            onClick={this.handleSubmit}
                          >
                            <b>Pesquisar</b>
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {!this.state.sync && (
            <Row>
              <Col className="order-xl-1" xl="12">
                <Button
                  className="mt-4 btn-zoo-alt"
                  color="primary"
                type="button"
                onClick={() => {
                  this.syncContaOvos();
              }}
              >
                <b>Enviar Dados</b>
              </Button>
            </Col>
          </Row> )}
          {this.state.response && !this.state.requesting && (
            <DataTable
              noHeader={true}
              pagination={true}
              striped={true}
              columns={this.columns}
              sortable={true}
              responsive={true}
              highlightOnHover={true}
              data={this.state.response}
              noDataComponent="Nenhum registro encontrado."
              paginationComponentOptions={this.defaultComponentOptions}
              customStyles={this.customStyles}
            />
          )}
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
      </>
    );
  }
}
